// extracted by mini-css-extract-plugin
export var quantityInput = "_o8-0";